import { db } from "./Firebase";
import { useEffect, useState } from "react";
import { Delete } from "@mui/icons-material";
import Navbar from "./Navbar";

export default function Category() {
    const [data, setdata] = useState([]);

    function submit(e) {
        e.preventDefault();
        const formData = new FormData(e.currentTarget);
        const categoryname = formData.get("categoryname");

        db.collection("Category").add({
            CategoryName: categoryname,
        }).then(() => {
            e.target.reset();
        });
    }

    function getdata() {
        db.collection("Category").onSnapshot((snapshot) => {
            setdata(snapshot.docs);
        });
    }

    useEffect(() => {
        getdata();
    }, []);

    function delt(id) {
        db.collection("Category").doc(id).delete();
    }

    return (
        <>
            <Navbar />
            <div className="catg row m-0">
                <h1 className="display-3 catg2 fw-bold text-dark">Category</h1>

                <div className="catg2 col-lg-5">
                    <div className="card catg1">
                        <div className="card-body">
                            <form onSubmit={submit}>
                                <div className="fw-bold">Category Name:</div>
                                <input
                                    type="text"
                                    name="categoryname"
                                    placeholder="Category Name"
                                    className="form-control my-2 mb-4"
                                    required
                                />
                                <button className="btn btn-dark px-5 fw-bold">Add</button>
                            </form>
                        </div>
                    </div>
                </div>

                <div className="col-lg-5">
                    <div className="card">
                        <div className="card-body">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Category Name</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((row) => (
                                        <tr key={row.id}>
                                            <td>{row.data().CategoryName}</td>
                                            <td>
                                                <button
                                                    onClick={() => delt(row.id)}
                                                    className="btn btn-danger btn-sm"
                                                >
                                                    <Delete />
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
